import { ApiError } from "../api/types";

export function isApiError(error: unknown): error is ApiError {
  return typeof error === "object" && error !== null && "statusCode" in error && "message" in error;
}
